import { render, staticRenderFns } from "./RegisterClubInfo.vue?vue&type=template&id=defb5bca&"
import script from "./RegisterClubInfo.vue?vue&type=script&lang=js&"
export * from "./RegisterClubInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports